/**
 * Modo del diálogo de configuración de horario.
 * - Normal: horario base del contrato (con teletrabajo).
 * - WeekException: excepción para una semana concreta (sin teletrabajo).
 */
export enum ScheduleMode {
  Normal = 'normal',
  WeekException = 'week_exception',
}
